import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.salesman-sales-report",
    url: "/vendas-por-vendedor",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Vendas por Vendedor",
        priority: 500,
        authorization: context =>
          context.user.permissions.includes("view_closed_sales"),
        state: "app.management.salesman-sales-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/salesman-sales-report/index.js